import {CSSProperties} from 'react';
import uuid from 'uuid-random';

import {
  CreateContactEmailFormFieldModel,
  CreateContactFormFieldTypesEnum,
  CreateContactFormFieldValidityStatusesEnum,
  CreateContactLinkFieldModel,
  CreateContactPhoneFormFieldModel,
  CreateContactTwitterHandleFormFieldModel,
} from '../store/panels/contacts/createContactForm/createContactFormState';

export function buildCreateContactFormEmail(value: string = ''): CreateContactEmailFormFieldModel {
  return {
    type: CreateContactFormFieldTypesEnum.EMAIL,
    uid: uuid(),
    value,
  };
}

export function buildCreateContactFormPhone(value: string = ''): CreateContactPhoneFormFieldModel {
  return {
    type: CreateContactFormFieldTypesEnum.PHONE_NUMBER,
    uid: uuid(),
    value,
  };
}

export function buildCreateContactFormTwitterField(
  value: string = '',
): CreateContactTwitterHandleFormFieldModel {
  return {
    type: CreateContactFormFieldTypesEnum.TWITTER,
    uid: uuid(),
    value,
  };
}

export function buildCreateContactLinkField(value: string = ''): CreateContactLinkFieldModel {
  return {
    uid: uuid(),
    value,
  };
}

export function computeIsCreateContactFormFieldErred(
  hasValue: boolean,
  validity?: CreateContactFormFieldValidityStatusesEnum,
) {
  if (!hasValue || !validity) {
    return false;
  }
  return (
    validity !== CreateContactFormFieldValidityStatusesEnum.VALID &&
    validity !== CreateContactFormFieldValidityStatusesEnum.TO_BE_CHECKED
  );
}

export function buildCreateContactFormBoxStyles(
  isFirst: boolean,
  hasError?: boolean,
  maxWidth?: number,
): CSSProperties {
  const bottomMargin = hasError ? '4px' : '8px';
  return {
    margin: isFirst ? `12px 0 ${bottomMargin} 0` : `0 0 ${bottomMargin} 0`,
    maxWidth: maxWidth ? `${maxWidth}px` : undefined,
  };
}
